module.exports = __webpack_public_path__ + "img/guizhouHints_7.2fef8723.jpg";